import { render, staticRenderFns } from "./DetailDeviceLend.vue?vue&type=template&id=2d066459"
import script from "./DetailDeviceLend.vue?vue&type=script&lang=js"
export * from "./DetailDeviceLend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports